import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import ButtonAntd from '@deprecated-ui/common/Button';
import BaseInputNumber from '@deprecated-ui/common/InputNumber';
import color from '@deprecated-ui/_style/color';
import styled, { css } from 'styled-components';

export const FormWrapper = styled.div`
  padding: 14px 8px;
  height: 451px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

interface IButtonChip {
  isActive?: boolean;
}

export const ButtonChip = styled.button <IButtonChip>`
  display: flex;
  height: 28px;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 15px;
  border: 1px solid ${({ isActive }) => isActive ? color.primary : color.downgray};
  box-shadow: unset;
  transition: unset;
  background: ${color.light};
  cursor: pointer;

  > p {
    color: #858585;
  }

  ${({ isActive }) => isActive && css`
    > p {
      color: ${color.primary};
      font-weight: 700;
    }
  `}
`;

export const NumberInput = styled(BaseInputNumber).attrs({
  controls: false,
})`
  padding: 12px;
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  flex: 1 0 0;
  align-self: stretch;

  > .ant-input-number-input-wrap {
    height: 19px;
    line-height: 19px;
  }
  
  input {
    padding: 0;
    height: 19px;
    line-height: 19px;
    font-size: 14px;
  }
`;

export const TextErrorMessage = styled(Text)`
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  color: ${color.sunsetOrange};
`;

export const FormFooterWrapper = styled(Flex)`
  padding: 10px 8px;
  gap: 8px;
  border-top: 1px solid ${color.downgray};
`;

export const Button = styled(ButtonAntd)`
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  padding: 6px 0;
  cursor: pointer;

  ${({ type }) => type === 'primary' && css`
    :disabled {
      color: ${color.light};
      background: ${color.hummingBird} !important;
    }

    :hover:disabled {
      color: ${color.light};
    }
  `}
`;

export const Dot = styled.div`
  position: absolute;
  top: 4px;
  left: 19px;
  width: 4px;
  height: 4px;
  background: ${color.primary};
  border-radius: 50%;
`;

export const TimePickerPopoverContainer = styled.div`
  .ant-picker-time-panel {
    width: auto;
  }
  .ant-picker-time-panel-column {
    width: 56px;
    padding-left: 6px;
    padding-right: 4px;
    overflow-y: scroll;

    .ant-picker-time-panel-cell-inner {
      width: 43px;
      text-align: center;
      padding-left: 0!important;
      font-size: 13px;
      font-family: 'ProximaNovaRg';
    }

    .ant-picker-time-panel-cell-selected > .ant-picker-time-panel-cell-inner {
      border-radius: 4px;
    }

    .ant-picker-time-panel-cell-disabled {
      display: none;
    }
  }

  .ant-picker-ranges {
    padding: 8px 6px;
  }

  .ant-picker-now-btn {
    font-size: 12px !important;
    font-family: 'ProximaNovaBd';
    padding-left: 12px;
    padding-right: 12px;
    height: 28px;
  }
  
  .ant-picker-ok {
    float: none;
    margin-left: 4px;
    height: 28px;

    .ant-btn {
      width: 42px;
      height: 28px;
      span {
        font-family: 'ProximaNovaBd';
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
`;

export const TimePickerInputContainer = styled(Flex).attrs({
  mb: '6px',
})`
  gap: 16px;

  .ant-picker {
    width: 142px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #EDEDED;
  }
`;
